<kiwi-competitive-intelligence
    [barChartLabel]="'studies.competitive.intelligence.price'"
    [teamValueLabelKey]="'studies.competitive.intelligence.price'"
    [comparisonStudy]="study"
></kiwi-competitive-intelligence>
